<footer class="footer">
	<small>NAHIDH V 1.0</small>
	<small class="ml-2 mr-2">- {{ "lang_copyright" | language }} -</small>
	<small>Made in KSA Riyadh 💚</small>
</footer>
